import Icon from './Icon'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class SortableTableHeader extends Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired
  }

  static defaultProps = {
    order: 'asc'
  }

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  shouldComponentUpdate(nextProps) {
    const { active, order, label } = this.props

    return (
      active !== nextProps.active ||
      order !== nextProps.order ||
      label !== nextProps.label
    )
  }

  handleClick(e) {
    e.preventDefault()

    let order = this.props.order === 'asc' ? 'desc' : 'asc'
    if (!this.props.active) {
      order = 'asc'
    }

    this.props.onClick(order)
  }

  render() {
    const { active, order, label } = this.props
    const direction = classNames({
      down: order === 'desc',
      up: order === 'asc'
    })

    return (
      <a onClick={this.handleClick}>
        {I18n.t(label)}
        {active && (
          <Icon name={`chevron-${direction}`} className="marginLeft5" />
        )}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/SortableTableHeader.js